import React from 'react';

import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';

import SmallerSpinner from '../../../../../../components/SmallerSpinner';
import DrugSearchInputClean from '../../DrugSearchInputClean.jsx';

export default function RowQuantity({ styles, rsStyles, f, errors = {}, dosageFormOptions = [], otherDosageForm, setOtherDosageForm }) {
  const handleCostChange = (e) => {
    const raw = String(e.target.value || '');
    const digitsOnly = raw.replace(/[^0-9]/g, '');
    const cleaned = digitsOnly.replace(/^0+(?=\d)/, '');
    f.setCost(cleaned);
  };

  const baseDosageOptions = Array.isArray(dosageFormOptions) ? dosageFormOptions : [];
  const unique = Array.from(new Set(baseDosageOptions));
  let dosageOptions =
    f.dosageForm && f.dosageForm !== 'Other' && !unique.includes(f.dosageForm)
      ? [f.dosageForm, ...unique]
      : unique;

  // Always ensure "Other" is present exactly once at end
  dosageOptions = [
    ...dosageOptions.filter(opt => String(opt) !== 'Other'),
    'Other',
  ];

  // Custom search function for dosage forms
  const searchDosageForms = (term) => {
    const filtered = dosageOptions.filter(option =>
      String(option).toLowerCase().includes(term.toLowerCase())
    );
    return filtered.map(option => ({
      sku: option,
      name: option,
      dosageForm: option
    }));
  };

  return (
    <FormRow className={rsStyles.rowSpinnersMid}>
      <Field label="Dosage Form" error={errors?.dosageform} className={rsStyles.fieldWithOverlay}>
        <DrugSearchInputClean
          id="dosage-form-search"
          initialValue={f.dosageForm || ''}
          placeholder="Search dosage form"
          searchBackend={searchDosageForms}
          getDisplayValue={(item) => item?.name || ''}
          dropdownOnly={true}
          openDropdownOnFocus={true}
          minSearchLength={0}
          onSelect={(item) => {
            const dosageForm = item?.name || '';
            f.setDosageForm(dosageForm);
            if (dosageForm !== 'Other') {
              setOtherDosageForm('');
            }
          }}
          size="default"
          borderRadius="8px"
          noResultsMessage="No dosage forms found"

        />
        {f.dosageForm === 'Other' && (
          <div className={rsStyles.inlineBelow}>
            <input
              className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
              type="text"
              placeholder="Enter dosage form"
              value={otherDosageForm}
              onChange={e => setOtherDosageForm(e.target.value)}
            />
          </div>
        )}
      </Field>
      <div className={rsStyles.inlineControls}>
        <Field label="Quantity" className={styles.compactField}>
          <SmallerSpinner
            compact
            value={f.quantity}
            onChange={f.setQuantity}
            className={rsStyles.nudgeSpinner}
          />
        </Field>
        <Field label="Reorder Level" className={styles.compactField}>
          <SmallerSpinner
            compact
            value={f.reorderLevel}
            onChange={f.setReorderLevel}
            className={rsStyles.nudgeSpinner}
          />
        </Field>
      </div>

      <Field label="Cost" error={errors?.costprice}>
        <input
          className={styles.tallInput}
          type="text"
          value={`R ${String(f.cost || '')}`}
          onChange={handleCostChange}
          placeholder="R 0"
        />
      </Field>
    </FormRow>
  );
}
